import { c as _c } from "react/compiler-runtime";
import { FormInput, Modal, PrimaryButton, toast } from '@systemeio/ui';
import { ErrorResponseContentInterface } from '@systemeio/util';
import { AffiliateWithdrawalTypesEnum } from 'modules/profile/affiliate-settings/enums/affiliate-withdrawal-enum';
import { useWiseRecipientApi } from 'modules/profile/affiliate-settings/hooks/use-wise-recipient-api';
import { AffiliateSettingsInterface, WiseRecipientApiInterface, WiseRecipientInterface } from 'modules/profile/affiliate-settings/types/affiliate-settings-interface';
import { WiseRecipientDetailsInterface } from 'modules/profile/affiliate-settings/types/wise-details-interface';
import { AdditionalFormFields } from 'modules/profile/affiliate-settings/utils/get-wise-recipient-form';
import React, { useState } from 'react';
import { Loader } from 'shared/components/loader';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { KeyedMutator } from 'swr';
const defaultErrors: ErrorResponseContentInterface = {
  common: [],
  fields: {}
};
interface EditBankDetailsModal {
  wiseRecipient: WiseRecipientInterface;
  mutateAffiliateSettings: KeyedMutator<AffiliateSettingsInterface>;
}
function EditBankDetailsModal(t0) {
  const $ = _c(68);
  const {
    wiseRecipient,
    mutateAffiliateSettings
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  let t1;
  if ($[0] !== wiseRecipient.accountHolderName || $[1] !== wiseRecipient.currency || $[2] !== wiseRecipient.details || $[3] !== wiseRecipient.recipientDetailsType) {
    t1 = {
      accountHolderName: wiseRecipient.accountHolderName,
      currency: wiseRecipient.currency,
      details: wiseRecipient.details,
      recipientDetailsType: wiseRecipient.recipientDetailsType
    };
    $[0] = wiseRecipient.accountHolderName;
    $[1] = wiseRecipient.currency;
    $[2] = wiseRecipient.details;
    $[3] = wiseRecipient.recipientDetailsType;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const [tempState, setTempState] = useState(t1);
  const [formData, setFormData] = useState(null);
  const [isFetching, setIsFetching] = useState(false);
  const [errors, setErrors] = useState(defaultErrors);
  const {
    getCurrentWiseRecipientDetails,
    updateWiseRecipientDetails
  } = useWiseRecipientApi();
  let t2;
  if ($[5] !== formData || $[6] !== getCurrentWiseRecipientDetails || $[7] !== tempState || $[8] !== wiseRecipient.currency) {
    t2 = async function onModalOpen() {
      if (!formData) {
        ;
        try {
          setIsFetching(true);
          const responseData = await getCurrentWiseRecipientDetails(wiseRecipient.currency, tempState);
          setFormData(responseData);
          setIsFetching(false);
        } catch (t3) {
          setIsFetching(false);
        }
      }
    };
    $[5] = formData;
    $[6] = getCurrentWiseRecipientDetails;
    $[7] = tempState;
    $[8] = wiseRecipient.currency;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const onModalOpen = t2;
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = function handleChangeWiseRecipientDetails(key, value) {
      setTempState(prev => ({
        ...prev,
        details: {
          ...prev.details,
          [key]: value
        }
      }));
    };
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const handleChangeWiseRecipientDetails = t3;
  let t4;
  if ($[11] !== tempState.recipientDetailsType) {
    t4 = function handleChangeRecipientDetailsType(value_0) {
      if (value_0 !== tempState.recipientDetailsType) {
        setTempState(prev_0 => ({
          ...prev_0,
          recipientDetailsType: value_0,
          details: {}
        }));
      }
    };
    $[11] = tempState.recipientDetailsType;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const handleChangeRecipientDetailsType = t4;
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = function resetFormErrors() {
      setErrors(defaultErrors);
    };
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const resetFormErrors = t5;
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = function updateFormDetails(details) {
      setTempState(prev_1 => ({
        ...prev_1,
        details
      }));
    };
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const updateFormDetails = t6;
  let t7;
  if ($[15] !== mutateAffiliateSettings || $[16] !== t || $[17] !== tempState || $[18] !== updateWiseRecipientDetails || $[19] !== wiseRecipient.id) {
    t7 = async function handleConfirm() {
      ;
      try {
        setIsFetching(true);
        resetFormErrors();
        const responseData_0 = await updateWiseRecipientDetails(wiseRecipient.id, tempState);
        await mutateAffiliateSettings(data => {
          if (data) {
            return {
              ...data,
              wiseRecipients: data.wiseRecipients.map(recipient => {
                if (recipient.id === wiseRecipient.id) {
                  return responseData_0;
                }
                return recipient;
              }),
              withdrawalMethod: AffiliateWithdrawalTypesEnum.bank_transfer
            };
          }
        }, false);
        setIsFetching(false);
        setOpened(false);
        toast.success(t("global.changes_saved"));
      } catch (t8) {
        setIsFetching(false);
      }
    };
    $[15] = mutateAffiliateSettings;
    $[16] = t;
    $[17] = tempState;
    $[18] = updateWiseRecipientDetails;
    $[19] = wiseRecipient.id;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  const handleConfirm = t7;
  let t8;
  if ($[21] !== onModalOpen) {
    t8 = () => {
      setOpened(true);
      onModalOpen();
    };
    $[21] = onModalOpen;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t) {
    t9 = t("dashboard.user_settings.affiliate_commissions.wire_table.edit_bank_details_title");
    $[23] = t;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t8 || $[26] !== t9) {
    t10 = <div onClick={t8} className="text-brand-primary cursor-pointer">{t9}</div>;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setOpened(false);
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t) {
    t12 = t("dashboard.user_settings.affiliate_commissions.wire_table.edit_bank_details_title");
    $[29] = t;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  const t13 = tempState.accountHolderName;
  let t14;
  if ($[31] !== t) {
    t14 = t("dashboard.user_settings.affiliate_commissions.account_holder_name_title");
    $[31] = t;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = e_1 => setTempState(prev_2 => ({
      ...prev_2,
      accountHolderName: e_1.target.value
    }));
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== errors.fields.accountHolderName) {
    t16 = errors.fields.accountHolderName?.join("");
    $[34] = errors.fields.accountHolderName;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t14 || $[37] !== t16 || $[38] !== tempState.accountHolderName) {
    t17 = <FormInput value={t13} label={t14} onChange={t15} error={t16} required={true} />;
    $[36] = t14;
    $[37] = t16;
    $[38] = tempState.accountHolderName;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== errors.fields || $[41] !== formData || $[42] !== handleChangeRecipientDetailsType || $[43] !== tempState) {
    t18 = formData ? <AdditionalFormFields formData={formData} setFormData={setFormData} state={tempState} onChangeDetails={handleChangeWiseRecipientDetails} onChangeRecipientDetailsType={handleChangeRecipientDetailsType} fieldErrors={errors.fields} resetFormErrors={resetFormErrors} updateFormDetails={updateFormDetails} /> : <div className="flex justify-center"><Loader /></div>;
    $[40] = errors.fields;
    $[41] = formData;
    $[42] = handleChangeRecipientDetailsType;
    $[43] = tempState;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== errors.common) {
    t19 = errors.common && <>{errors.common.map(_temp)}</>;
    $[45] = errors.common;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t17 || $[48] !== t18 || $[49] !== t19) {
    t20 = <div className="flex flex-col justify-center gap-3">{t17}{t18}{t19}</div>;
    $[47] = t17;
    $[48] = t18;
    $[49] = t19;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  const t21 = !formData || isFetching;
  let t22;
  if ($[51] !== t) {
    t22 = t("global.save");
    $[51] = t;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== handleConfirm || $[54] !== t21 || $[55] !== t22) {
    t23 = <div className="flex justify-center gap-4"><PrimaryButton type="button" onClick={handleConfirm} disabled={t21}>{t22}</PrimaryButton></div>;
    $[53] = handleConfirm;
    $[54] = t21;
    $[55] = t22;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  let t24;
  if ($[57] !== t20 || $[58] !== t23) {
    t24 = <form className="flex flex-col gap-6 lg:gap-10">{t20}{t23}</form>;
    $[57] = t20;
    $[58] = t23;
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  let t25;
  if ($[60] !== isFetching || $[61] !== opened || $[62] !== t12 || $[63] !== t24) {
    t25 = <Modal isFetching={isFetching} opened={opened} onClose={t11} title={t12}>{t24}</Modal>;
    $[60] = isFetching;
    $[61] = opened;
    $[62] = t12;
    $[63] = t24;
    $[64] = t25;
  } else {
    t25 = $[64];
  }
  let t26;
  if ($[65] !== t10 || $[66] !== t25) {
    t26 = <>{t10}{t25}</>;
    $[65] = t10;
    $[66] = t25;
    $[67] = t26;
  } else {
    t26 = $[67];
  }
  return t26;
}
function _temp(error, index) {
  return <p className="text-red px-6 text-center text-sm" key={index}>{error}</p>;
}
export default EditBankDetailsModal;